export default function ({ route, redirect }) {
    const isMaintenanceMode = process.env.MAINTENANCE_MODE === 'true';

    if (isMaintenanceMode && route.path !== '/maintenance') {
        return redirect('/maintenance');
    }
} 